import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import Loader from "../../Components/Common/Loader";
import SearchableSelect from "../../Components/Common/SearchableSelect";

import {
  adminGetAllAttendance,
  adminGetAllAttendanceByPhoto,
  adminGetAllPatrol,
  adminGetAllWorkExtension,
  adminGetComboMember,
} from "helpers/backend_helpers";
import { formatDate } from "helpers/globalFunction";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import WorkExtensionModalConfiguration from "./WorkExtensionModalConfiguration";
// import WorkActivitiesDetail from "./WorkActivitiesDetail";

const WorkExtension = () => {
  const [tableData, setTableData] = useState<any>([]);
  const [data, setData] = useState<any>({});
  const [sort, setSort] = useState("createTime");
  const [dir, setDir] = useState(-1);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);

  const [detailModal, setDetailModal] = useState<boolean>(false);
  const [downloadModal, setDownloadModal] = useState<boolean>(false);

  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [filterDate, setFilterDate] = useState<any>([]);
  const [filterDateExtension, setFilterDateExtension] = useState<any>([]);
  const [filterCategory, setFilterCategory] = useState<any>(null);
  const [filterMember, setFilterMember] = useState<any>(null);
  const [flatpickrKey, setFlatpickrKey] = useState(0);
  const [flatpickrKeyExtension, setFlatpickrKeyExtension] = useState(0);

  const getData = () => {
    setLoading(true);
    let query: any = {
      page: pagination.pageIndex,
      size: pagination.pageSize,
      sort: sort,
      dir: dir,
    };

    if (filterDate[0] && filterDate[1]) {
      query.startDate = moment(filterDate[0]).format("YYYY-MM-DD");
      query.endDate = moment(filterDate[1]).format("YYYY-MM-DD");
    }
    if (filterDateExtension[0] && filterDateExtension[1]) {
      query.startExtensionDate = moment(filterDateExtension[0]).format(
        "YYYY-MM-DD"
      );
      query.endExtensionDate = moment(filterDateExtension[1]).format(
        "YYYY-MM-DD"
      );
    }
    if (filterMember) {
      query.userId = filterMember.value;
    }

    adminGetAllWorkExtension(query)
      .then((response: any) => {
        setTableData(
          response.content.map((el: any, index: any) => {
            const { createTime, extensionDate } = el;
            return {
              ...el,
              index: index + pagination.pageIndex * pagination.pageSize + 1,
              tanggal: formatDate(createTime, "fullDateTime") || "-",
              tanggalLembur: formatDate(extensionDate, "full") || "-",
            };
          })
        );
        setRowCount(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const searchMembers = async (name: string) => {
    const query = { name };
    return await adminGetComboMember(query);
  };

  const formatMemberOption = (member: any) => {
    return {
      label: `${member.name} - ${member.noId}`,
      value: member._id,
    };
  };

  const handleResetFilter = () => {
    setFilterDate([]);
    setFilterDateExtension([]);
    setFilterMember(null);
    setFlatpickrKey((prev) => prev + 1);
    setFlatpickrKeyExtension((prev) => prev + 1);
  };

  const handleToggleFilter = () => {
    if (showFilter) {
      handleResetFilter();
    }
    setShowFilter(!showFilter);
  };

  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "index",
        enableColumnFilter: false,
        enableSorting: false,
        size: 50,
      },
      {
        header: "Tanggal Pengajuan",
        accessorKey: "tanggal",
        enableColumnFilter: false,
        enableSorting: false,
        size: 180,
      },
      {
        header: "Tanggal Lembur",
        accessorKey: "tanggalLembur",
        enableColumnFilter: false,
        enableSorting: false,
        size: 180,
      },
      {
        header: "Nama Karyawan",
        accessorKey: "member.name",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "No Reg",
        accessorKey: "member.noId",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Nama Shift",
        accessorKey: "shift.name",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Durasi Lembur Sebelum Shift",
        accessorKey: "durationBeforeShiftMinutes",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
        cell: (cell: any) => cell.getValue() + " menit",
      },
      {
        header: "Durasi Lembur Setelah Shift",
        accessorKey: "durationAfterShiftMinutes",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
        cell: (cell: any) => cell.getValue() + " menit",
      },
      {
        accessorKey: "status",
        header: "Status",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
        cell: (cell: any) => {
          switch (cell.getValue()) {
            case "PENDING":
              return (
                <span className="badge text-uppercase bg-primary-subtle text-primary">
                  MENUNGGU KONFIRMASI
                </span>
              );
            case "ACCEPTED":
              return (
                <span className="badge text-uppercase bg-success-subtle text-success">
                  DISETUJUI
                </span>
              );
            case "REJECTED":
              return (
                <span className="badge text-uppercase bg-danger-subtle text-danger">
                  DITOLAK
                </span>
              );
            default:
              return (
                <span className="badge text-uppercase bg-info-subtle text-info">
                  -
                </span>
              );
          }
        },
      },
      {
        header: "Aksi",
        enableColumnFilter: false,
        enableSorting: false,
        size: 250,
        cell: (cellProps: any) => {
          return (
            <div className="d-flex align-items-center gap-2">
              <UncontrolledTooltip
                target={`detail-${cellProps.row.original._id}`}
                placement="top"
              >
                {cellProps.row.original.status === "PENDING"
                  ? "Konfirmasi Lembur"
                  : "Lihat Detail"}
              </UncontrolledTooltip>

              <button
                id={`detail-${cellProps.row.original._id}`}
                className={`btn btn-sm ${
                  cellProps.row.original.status === "PENDING"
                    ? "btn-primary"
                    : "btn-outline-secondary"
                }`}
                onClick={() => {
                  setDetailModal(!detailModal);
                  setData(cellProps.row.original);
                }}
                style={{
                  borderRadius: "8px",
                  padding: "6px 12px",
                  fontWeight: "500",
                  minWidth: "90px",
                }}
              >
                <i
                  className={`${
                    cellProps.row.original.status === "PENDING"
                      ? "ri-settings-2-line"
                      : "ri-eye-line"
                  } me-1`}
                />
                {cellProps.row.original.status === "PENDING"
                  ? "Konfirmasi"
                  : "Detail"}
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    getData();
  }, [pagination, sort, dir, filterDate, filterDateExtension, filterMember]);

  document.title = "Data Lembur";

  return (
    <React.Fragment>
      <WorkExtensionModalConfiguration
        show={detailModal}
        onCloseClick={() => setDetailModal(!detailModal)}
        getData={() => getData()}
        data={data}
      />
      {/* <DownloadModalAttendance
        show={downloadModal}
        onCloseClick={() => setDownloadModal(!downloadModal)}
      /> */}
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Data Lembur" pageTitle="Lembur" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">
                  <div className="d-flex align-items-center">
                    <h5 className="card-title mb-0 flex-grow-1">Data Lembur</h5>
                    <div className="flex-shrink-0">
                      <div className="d-flex gap-2 flex-wrap">
                        <button
                          className="btn btn-soft-primary btn-sm"
                          onClick={handleToggleFilter}
                        >
                          <i className="ri-filter-3-line align-bottom me-1"></i>
                          Filters
                        </button>
                        {/* <button
                          className="btn btn-soft-dark btn-sm"
                          onClick={() => setDownloadModal(!downloadModal)}
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>
                          Unduh Data Aktivitas Pekerjaan
                        </button> */}
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="pt-0">
                  <Collapse isOpen={showFilter}>
                    <Row className="g-3 mb-4">
                      <Col lg={3}>
                        <div>
                          <Flatpickr
                            key={flatpickrKey}
                            className="form-control"
                            options={{
                              mode: "range",
                              dateFormat: "d M Y",
                            }}
                            onChange={(e) => {
                              setFilterDate(e);
                            }}
                            value={filterDate}
                            placeholder="Pilih Tanggal Pengajuan"
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div>
                          <Flatpickr
                            key={flatpickrKeyExtension}
                            className="form-control"
                            options={{
                              mode: "range",
                              dateFormat: "d M Y",
                            }}
                            onChange={(e) => {
                              setFilterDateExtension(e);
                            }}
                            value={filterDateExtension}
                            placeholder="Pilih Tanggal Lembur"
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <SearchableSelect
                          value={filterMember}
                          onChange={setFilterMember}
                          onSearch={searchMembers}
                          formatOptionLabel={formatMemberOption}
                          placeholder="Cari Karyawan"
                          minSearchLength={2}
                          itemsPerPage={5}
                          isClearable
                        />
                      </Col>
                      <Col lg={12}>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-soft-secondary btn-sm"
                            onClick={handleResetFilter}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>
                            Reset
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Collapse>
                  <div>
                    {loading ? (
                      <Loader />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={tableData || []}
                        customPageSize={10}
                        theadClass="text-muted text-uppercase"
                        manualPagination
                        pagination={pagination}
                        pageCount={totalPages}
                        onPaginationChange={setPagination}
                        divClass="table-responsive"
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default WorkExtension;
